import { render, staticRenderFns } from "./InactivityPopup.vue?vue&type=template&id=b1c4cdc6&"
import script from "./InactivityPopup.vue?vue&type=script&lang=ts&"
export * from "./InactivityPopup.vue?vue&type=script&lang=ts&"
import style0 from "./InactivityPopup.vue?vue&type=style&index=0&id=b1c4cdc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports